import axiosClient from "axiosClient";
import { axiosHyperwolfClient } from "axiosClient";
import axiosClientStilo from "axiosClient/indexStilo";
import { getQueryString } from "utilities/common";
import { STILO } from "utilities/constants";
import { HEMP } from "utilities/constants";

const adminsMode = JSON.parse(localStorage.getItem('adminsMode'))

export async function fetchTerpenoidsAPI(filters) {
    return await axiosClient.get(`/api/v1/product/terpenoids/?${getQueryString(filters)}`);
}

export async function fetchTerpenoidDetailsAPI(terpenoidId) {
    return await axiosClient.get(`/api/v1/product/terpenoids/${terpenoidId}`);
}

export async function addTerpenoidAPI(data) {
    return await axiosClient.post(`/api/v1/product/terpenoids`, data);
}

export async function updateTerpenoidAPI(data, terpenoidId) {
    return await axiosClient.put(`/api/v1/product/terpenoids/${terpenoidId}`, data);
}
export async function updateMemberAPI(data, terpenoidId) {
    return await axiosClient.put(`/api/v1/product/terpenoids/update/${terpenoidId}`, data);
}

export async function deleteTerpenoidAPI({ terpeneId, productId }) {
    return await axiosClient.post(`/api/v1/product/delete/terpenoids/${productId}`, { terpeneId });
}

export async function deleteMainTerpenoidAPI(terpeneId) {
    return await axiosClient.delete(`/api/v1/product/terpenoids/${terpeneId}`);
}

export async function fetchMemberOrdersAPI(data, terpenoidId) {
    return await axiosClient.get(`/api/v1/product/terpenoids/?terpenoidId=${terpenoidId}`, data);
}


export async function addTerpenoidToProductAPI(data, productId) {
    return await axiosClient.post(`/api/v1/product/assign/terpenoids/${productId}`, { terpenoidsData: data });
}

export async function updateTerpenoidToProductAPI(data, productId) {
    return await axiosClient.put(`/api/v1/product/update/terpenoids/${productId}`, { ...data });
}

// cannabinoids


export async function getMainCannabinoidAPI() {
    return await (adminsMode === HEMP ? axiosClient : adminsMode === STILO ? axiosClientStilo : axiosHyperwolfClient).get(`/api/v1/cannabinoid/main/page`);
}

export async function updateMainCannabinoidAPI(data) {
    return await (adminsMode === HEMP ? axiosClient : adminsMode === STILO ? axiosClientStilo : axiosHyperwolfClient).post(`/api/v1/cannabinoid/update/main/metas`, data);
}


export async function getCannabinoidsListAPI(data) {
    return await (adminsMode === HEMP ? axiosClient : adminsMode === STILO ? axiosClientStilo : axiosHyperwolfClient).get(`/api/v1/cannabinoid?${getQueryString(data)}&userType=admin`);
}

export async function createCannabinoidAPI(data) {
    return await (adminsMode === HEMP ? axiosClient : adminsMode === STILO ? axiosClientStilo : axiosHyperwolfClient).post(`/api/v1/cannabinoid/create`, data);
}

export async function updateCannabinoidAPI({ data, id }) {
    return await (adminsMode === HEMP ? axiosClient : adminsMode === STILO ? axiosClientStilo : axiosHyperwolfClient).put(`/api/v1/cannabinoid/update/${id}`, data);
}

export async function getSingleCannabinoidAPI(id) {
    return await (adminsMode === HEMP ? axiosClient : adminsMode === STILO ? axiosClientStilo : axiosHyperwolfClient).get(`/api/v1/cannabinoid/${id}?userType=admin`);
}


export async function deleteCannabinoidAPI(id) {
    return await (adminsMode === HEMP ? axiosClient : adminsMode === STILO ? axiosClientStilo : axiosHyperwolfClient).delete(`/api/v1/cannabinoid/delete/${id}`);
}
export async function getCannabinoidBannersAPI(data) {
    return await (adminsMode === HEMP ? axiosClient : adminsMode === STILO ? axiosClientStilo : axiosHyperwolfClient).get(`/api/v1/banners/cannabinoid?${getQueryString(data)}&userType=admin`);
}
export async function createCannabinoidBannersAPI(data) {
    return await (adminsMode === HEMP ? axiosClient : adminsMode === STILO ? axiosClientStilo : axiosHyperwolfClient).post(`/api/v1/banners/cannabinoid`, data);
}


export async function updateSingleCannabinoidBannerAPI({ data, id }) {
    return await (adminsMode === HEMP ? axiosClient : adminsMode === STILO ? axiosClientStilo : axiosHyperwolfClient).put(`/api/v1/banners/cannabinoid/${id}`, data);
}

export async function getSingleCannabinoidBannerAPI(id) {
    return await (adminsMode === HEMP ? axiosClient : adminsMode === STILO ? axiosClientStilo : axiosHyperwolfClient).get(`/api/v1/banners/cannabinoid/${id}`);
}

export async function deleteCannabinoidBannerAPI(id) {
    return await (adminsMode === HEMP ? axiosClient : adminsMode === STILO ? axiosClientStilo : axiosHyperwolfClient).delete(`/api/v1/banners/cannabinoid/${id}`);
}